import { Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { FileSearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { adminMenuItems } from './config/menuItems';

const StyledMenu = styled(Menu)`
    &.ant-menu-inline .ant-menu-item,
    &.ant-menu-inline .ant-menu-submenu-title {
        padding-left: 8px !important;
        padding-right: 8px !important;
    }
`;

interface AdminMenuProps {
    username: string;
}

const AdminMenu = ({ username }: AdminMenuProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    const getSelectedKey = () => {
        const path = location.pathname;
        if (path.includes('/admin/board-category-permissions')) return 'board-category-permissions';
        if (path.includes('/admin/permissions')) return 'permissions';
        if (path.includes('/admin/users')) return 'users';
        if (path.includes('/admin/boards')) return 'boards';
        if (path.includes('/admin/category-editor')) return 'category-editor';
        if (path.includes('/admin/category')) return 'category';
        if (path.includes('/admin/signup')) return 'signup';
        if (path.includes('/admin/file-check')) return 'file-check';
        return 'users';
    };

    const handleMenuClick = ({ key }: { key: string }) => {
        switch (key) {
            case 'users':
                navigate('/admin/users');
                break;
            case 'permissions':
                navigate('/admin/permissions');
                break;
            case 'board-category-permissions':
                navigate('/admin/board-category-permissions');
                break;
            case 'boards':
                navigate('/admin/boards');
                break;
            case 'category':
                navigate('/admin/category');
                break;
            case 'category-editor':
                navigate('/admin/category-editor');
                break;
            case 'signup':
                navigate('/admin/signup');
                break;
            case 'file-check':
                navigate('/admin/file-check');
                break;
            default:
                break;
        }
    };

    const menuItems = [
        ...adminMenuItems,
        ...(username === 'humintec' ? [{
            key: 'file-check',
            icon: <FileSearchOutlined />,
            label: '슬라이드 파일 체크',
        }] : []),
    ];

    return (
        <StyledMenu
            mode="inline"
            selectedKeys={[getSelectedKey()]}
            items={menuItems}
            onClick={handleMenuClick}
        />
    );
};

export default AdminMenu;
